import * as Sentry from "@sentry/browser";

if (window.sentry_dsn) {
    Sentry.init({
        dsn: window.sentry_dsn,
        release: window.app_release,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 0.001,
        tracePropagationTargets: [
            /^https:\/\/www\.luxplus\.(be|co\.uk|dk|fi|nl|no|se)\//,
        ],
        profilesSampleRate: 0.0,
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 0.1,
        ignoreErrors: ["Non-Error promise rejection captured.+"],
    });
}
